import { useEffect, useState } from "react"
import type { MarkdownContent } from "../types"
import { parseMarkdown } from "../utils/markdown"

interface UseMarkdownContentResult {
  content: MarkdownContent | null
  loading: boolean
  error: Error | null
}

export function useMarkdownContent(filename: string): UseMarkdownContentResult {
  const [content, setContent] = useState<MarkdownContent | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    async function loadContent() {
      try {
        const response = await fetch(`/content/${filename}`)
        if (!response.ok) {
          throw new Error(`Failed to load ${filename}`)
        }

        const markdown = await response.text()
        const parsed = parseMarkdown(markdown)

        setContent(parsed)
      } catch (err) {
        setError(err as Error)
      } finally {
        setLoading(false)
      }
    }

    loadContent()
  }, [filename])

  return { content, loading, error }
}
